module.exports = require("lodash/object");


//////////////////
// WEBPACK FOOTER
// external "lodash/object"
// module id = 17
// module chunks = 0